<div class="dashboard-toggle" *ngIf="isProfissional">
  <span
    class="toggle-item"
    [class.active]="isActive('/app/profissional-saude/home')"
    (click)="goTo('/app/profissional-saude/home')">
    Dashboard de Profissional de Saúde
  </span>

  <span
    class="toggle-item"
    [class.active]="isActive('/app/paciente/dashboard')"
    (click)="goTo('/app/paciente/dashboard')">
    Dashboard do Paciente
  </span>
</div>
